import ServiceCRUD from '../../../services/ServiceCRUDSCALE';

class TimeShiftAgent extends ServiceCRUD {
  constructor() {
    super('/api/time-shift/agent');
  }
}

export default new TimeShiftAgent();
